export default __webpack_public_path__ + "static/media/permission.60bff456.svg";